const EMPTY_INSTANCE = {};
class TeaContainer {
  _assertIsInjected() {
    if (!this._injected)
      throw Error("[Tea] instance has not injected into container");
  }
  _inject(instance) {
    this._instance = instance;
    this._injected = true;
  }
  _setConfigInjector(injector) {
    this._configInjector = injector;
  }
  start() {
    this._instance.start();
  }
  config(config) {
    if (!config)
      return;
    this._instance.config(config);
  }
  collectEvent(event, params) {
    if (typeof event === "string")
      this._instance.collectEvent({
        eventName: event,
        params
      });
    else
      this._instance.collectEvent(event);
  }
  init(config) {
    const injectedConfig = this._configInjector();
    const teaConfig = {
      ...injectedConfig.config,
      ...config.config
    };
    this._doInit({
      ...injectedConfig,
      ...config,
      config: Object.keys(teaConfig).length ? teaConfig : void 0
    });
  }
  _doInit(config) {
    this._assertIsInjected();
    const Tea = this._instance;
    Tea.init(config);
    if (config.config || config.evtParams) {
      Tea.config({
        evtParams: config.evtParams,
        ...config.config
      });
    }
    if (config.autoStart) {
      this.start();
    }
  }
  create(prefix) {
    const container = new TeaContainer();
    const teaInstance = this._instance.create(prefix);
    container._inject(teaInstance);
    container._setConfigInjector(this._configInjector);
    return container;
  }
  call(fnName, ...args) {
    return this._instance.call(fnName, ...args);
  }
  constructor() {
    this._instance = EMPTY_INSTANCE;
    this._injected = false;
    this._configInjector = () => null;
  }
}
export {
  TeaContainer
};

//# sourceMappingURL=container.js.map